// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file dailyitems/list_all_daily_items.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { DailyItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListAllDailyItemsRequest
 */
export class ListAllDailyItemsRequest extends Message<ListAllDailyItemsRequest> {
  constructor(data?: PartialMessage<ListAllDailyItemsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListAllDailyItemsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAllDailyItemsRequest {
    return new ListAllDailyItemsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAllDailyItemsRequest {
    return new ListAllDailyItemsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAllDailyItemsRequest {
    return new ListAllDailyItemsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAllDailyItemsRequest | PlainMessage<ListAllDailyItemsRequest> | undefined, b: ListAllDailyItemsRequest | PlainMessage<ListAllDailyItemsRequest> | undefined): boolean {
    return proto3.util.equals(ListAllDailyItemsRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListAllDailyItemsResponse
 */
export class ListAllDailyItemsResponse extends Message<ListAllDailyItemsResponse> {
  /**
   * @generated from field: repeated com.neulink.pharmacy.DailyItem daily_items = 1;
   */
  dailyItems: DailyItem[] = [];

  constructor(data?: PartialMessage<ListAllDailyItemsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListAllDailyItemsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "daily_items", kind: "message", T: DailyItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAllDailyItemsResponse {
    return new ListAllDailyItemsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAllDailyItemsResponse {
    return new ListAllDailyItemsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAllDailyItemsResponse {
    return new ListAllDailyItemsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAllDailyItemsResponse | PlainMessage<ListAllDailyItemsResponse> | undefined, b: ListAllDailyItemsResponse | PlainMessage<ListAllDailyItemsResponse> | undefined): boolean {
    return proto3.util.equals(ListAllDailyItemsResponse, a, b);
  }
}

